import JSEncrypt from 'jsencrypt';

const PASSWORD_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiH6ua1HAE/jXVfIaKk6s
1P3KO6dLw4wCVXcBlBBFDMIrvt4J5I9mnNoFGcoLxI3ttHLHg9Ep5qBmdUmfn5LL
K0TJqwCE6nXJJagig89Nc22pOpcOPpF6R984ccFhwvgJiBrOW3gfhF5ALNVhwXsB
kUSByDlk7fnGjqD42n9S9KfGj+GKQ6gKR8Yw+1L2n2VgJ/4Pafc5/rE59uPnDKwL
z+QG+nGndH4PG9pm68jXHcBUfm6pUKO9Uczz1fmS+pV5AAf44ZRlCw6+QSstIs23
ADwprQjPvN/msrRV+QQAxd/Eoa1geeh36c+Nb8nubRSTgaQnXdZLR+PqvNMsoYUV
IwIDAQAB
-----END PUBLIC KEY-----`;

export const encryptPassword = (password: string): string => {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(PASSWORD_PUBLIC_KEY);
    const encrypted = encryptor.encrypt(password);
    if (!encrypted) throw new Error('密码加密失败');
    return encrypted;
};
